var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"site-logo",attrs:{"src":"/source/png/nftwerks-logo.png","alt":"NFTWerks"}})])
}]

export { render, staticRenderFns }